module.exports = __webpack_public_path__ + "static/media/feature-shot.f1ce4c86.png";